<template>
  <router-view></router-view>
  <footer-two></footer-two>
  <BaseLoading :dialog="true" v-if="sharedStore.loading"></BaseLoading>
</template>
<script>
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";

export default {
  components: {
    BaseLoading,
  },
  setup() {
    const sharedStore = useSharedStore();
    return {
      sharedStore,
    };
  },
};
</script>
